import { FEATURES, FeatureId } from 'services/features/catalog';
import { ConnectorCatalogItem, ConnectorType } from './types';

export const CONNECTOR_FEATURES: Record<ConnectorType, FeatureId> = {
  GITHUB: FEATURES.github,
  STRAVA: FEATURES.strava,
  SUBSTACK: FEATURES.substack,
  YOUTUBE: FEATURES.youtube,
};

export const CONNECTOR_CATALOG: ConnectorCatalogItem[] = [
  {
    type: 'GITHUB',
    label: 'GitHub',
    description: 'Monitor a GitHub repository',
    configFields: [
      { key: 'repository', label: 'Repository', required: false },
      { key: 'url', label: 'Repository URL', required: false },
    ],
  },
  {
    type: 'YOUTUBE',
    label: 'YouTube',
    description: 'Monitor a YouTube channel',
    configFields: [
      { key: 'handle', label: 'Channel handle', required: false },
      { key: 'channelId', label: 'Channel ID', required: false },
    ],
  },
  {
    type: 'SUBSTACK',
    label: 'Substack',
    description: 'Monitor a Substack publication',
    configFields: [
      { key: 'url', label: 'Publication URL', required: false },
      { key: 'subdomain', label: 'Subdomain', required: false },
    ],
  },
  {
    type: 'STRAVA',
    label: 'Strava',
    description: 'Monitor a Strava athlete',
    configFields: [
      { key: 'athleteId', label: 'Athlete ID', required: false },
      { key: 'url', label: 'Profile URL', required: false },
    ],
  },
];

export const normalizeCatalog = (
  catalog?: ConnectorCatalogItem[] | { catalog?: ConnectorCatalogItem[] } | null,
): ConnectorCatalogItem[] => {
  const items = Array.isArray(catalog)
    ? catalog
    : (catalog && Array.isArray(catalog.catalog) ? catalog.catalog : []);
  const byType = new Map(items.map(item => [item.type, item]));
  CONNECTOR_CATALOG.forEach(item => {
    if (!byType.has(item.type)) {
      byType.set(item.type, item);
    }
  });
  return [...byType.values()];
};
